import * as Yup from 'yup';

import { overviewFieldNames } from '../../models/overview-form-values';

export const overviewValidationSchema = () => {
    return Yup.object().shape({
        [overviewFieldNames.responsibleContact]: Yup.object().nullable().required('app.error.required'),
        [overviewFieldNames.invoiceDate]: Yup.date().required('app.error.required').typeError('app.error.required'),
        [overviewFieldNames.recipientAccount]: Yup.object().nullable().required('app.error.required'),
        [overviewFieldNames.supplierAccount]: Yup.object().nullable().required('app.error.required'),
        [overviewFieldNames.invoiceAddress]: Yup.object().nullable().required('app.error.required'),
        [overviewFieldNames.currency]: Yup.string().required('app.error.required'),
        [overviewFieldNames.paymentTerm]: Yup.object().nullable().required('app.error.required'),
        [overviewFieldNames.incomingInvoiceNumber]: Yup.string().nullable().max(250, 'app.error.maxLength'),
        [overviewFieldNames.functionalAsset]: Yup.object().nullable(),
    });
};
